<template>
  <div class="divDuplication">
    <label for="selectTiersSource">Tiers source :</label>&nbsp;
    <el-select id="selectTiersSource" v-model="selectTiersSourceValue" @change="onselectTiersSourceChange" placeholder="Sélectionnez un tiers">
      <el-option
          v-for="item in tiers_source"
          :key="item"
          :label="item.name"
          :value="item.id">
      </el-option>
    </el-select>
    
    <br/><br/>

    <label v-if="selectTiersSourceValue != ''" for="selectTiersCible">Tiers cible :</label>&nbsp;
    <el-select v-if="selectTiersSourceValue != ''" id="selectTiersCible" v-model="selectTiersCibleValue" @change="onselectTiersCibleChange" placeholder="Sélectionnez un tiers">
      <el-option
          v-for="item in tiers_cible"
          :key="item"
          :label="item.name"
          :value="item.id">
      </el-option>
    </el-select>

    <br/><br/>

    <el-button type="primary" v-if="DupplicationButtonVisible" @click="DupplicationButtonClicked" :disabled="this.isButtonDisabled()">Valider</el-button>
    <p><a id='TexteDonnéesVides' style="color:red;"></a></p>
  </div> 
</template>

<script>
import scriptQse from '../../../script/script-qse.js';
import script from '../../../script/script.js';

export default {
  data() {
    return {
      selectTiersSourceValue: '',
      selectTiersCibleValue: '',
      DupplicationButtonVisible: false,
      tiers_source: [],
      tiers_cible: [],
      qse_tiers_source: {},
      qse_tiers_cible: {}
    };
  },
  async mounted() {
    this.tiers_source = await scriptQse.loadingAllTiers();
  },
  methods: {
    onselectTiersSourceChange() {
      this.tiers_cible = this.tiers_source.filter(tiers => tiers.id != this.selectTiersSourceValue);
      this.qse_tiers_source = this.tiers_source.filter(tiers => tiers.id == this.selectTiersSourceValue)[0];
      this.selectTiersCibleValue = '';
      this.DupplicationButtonVisible = false;
      document.getElementById('TexteDonnéesVides').innerText = ""
    },

    onselectTiersCibleChange() {
      this.qse_tiers_cible = this.tiers_cible.filter(tiers => tiers.id == this.selectTiersCibleValue)[0];
      this.DupplicationButtonVisible = true;
      document.getElementById('TexteDonnéesVides').innerText = ""
    },

    DupplicationButtonClicked() {
      if (confirm(`Êtes-vous sûr de vouloir duppliquer les données de ${this.qse_tiers_source.name} vers ${this.qse_tiers_cible.name} ?`) == true){
        var donnes_tiers = 
          `Tiers Source: ${this.qse_tiers_source.name},\n
          cotation : ${this.qse_tiers_source.array_options.options_cotations},\n
          famillesRisques : ${this.qse_tiers_source.array_options.options_familles_risques},\n
          unites : ${this.qse_tiers_source.array_options.options_unite},\n
          donnees : ${this.qse_tiers_source.array_options.options_donnees},\n
          situations : ${this.qse_tiers_source.array_options.options_situations},\n
          annexeCovid : ${this.qse_tiers_source.array_options.options_annexe_covid},\n
          checklistGenerale : ${this.qse_tiers_source.array_options.options_checklist_generale},\n
          progAction : ${this.qse_tiers_source.array_options.options_prog_action},\n

          Tiers Cible: ${this.qse_tiers_cible.name},\n
          cotation : ${this.qse_tiers_cible.array_options.options_cotations},\n
          famillesRisques : ${this.qse_tiers_cible.array_options.options_familles_risques},\n
          unites : ${this.qse_tiers_cible.array_options.options_unite},\n
          donnees : ${this.qse_tiers_cible.array_options.options_donnees},\n
          situations : ${this.qse_tiers_cible.array_options.options_situations},\n
          annexeCovid : ${this.qse_tiers_cible.array_options.options_annexe_covid},\n
          checklistGenerale : ${this.qse_tiers_cible.array_options.options_checklist_generale},\n
          progAction : ${this.qse_tiers_cible.array_options.options_prog_action}`

        this.SaveFile(`${this.qse_tiers_source.name} - ${this.qse_tiers_cible.name}`,donnes_tiers);

        var body = {
        "options_cotation": this.qse_tiers_source.array_options.options_cotations,
        "options_unite": this.qse_tiers_source.array_options.options_unite,
        "options_donnees": this.qse_tiers_source.array_options.options_donnees,
        "options_familles_risques": this.qse_tiers_source.array_options.options_familles_risques,
        "options_situations": this.qse_tiers_source.array_options.options_situations,
        "options_prog_action": this.qse_tiers_source.array_options.options_prog_action,
        "options_checklist_generale": this.qse_tiers_source.array_options.options_checklist_generale,
        "options_annexe_covid": this.qse_tiers_source.array_options.options_annexe_covid,
        "options_date_maj": Date.now()
      }

      this.updateExtrafieldsQse(this.qse_tiers_cible.id,body);
      }
    },

    async SaveFile(path,content){
      try{
        await script.requestApi({method: 'POST', url: `/api/writeSaveFile`, params: {}, form: {path: path, content: content}, headers: {'Content-Type': 'application/json'}});
      }
      catch(error){
        console.error(error);
        scriptQse.toasterError(`Fichier de sauvegarde non-créé`,'Erreur');
      }
    },

    async updateExtrafieldsQse(idTiers, body) {
      try{
        await script.requestApi({method: 'POST', url: `/api/updateExtrafieldsQse/${idTiers}`, params: {}, form: body, headers: {'Content-Type': 'application/json'}});
        scriptQse.toasterSuccess(`Dupplication effectuée`,'Modifications')
      }
      catch(error){
        console.error(error);
        scriptQse.toasterError(`Dupplication non-effectuée`,'Erreur');
      }
    },

    isButtonDisabled(){
      if (this.qse_tiers_source.array_options.length === undefined){
        document.getElementById('TexteDonnéesVides').innerText = ""
        return false;
      }
      else{
        document.getElementById('TexteDonnéesVides').innerText = "Le tiers source ne contient aucune donnée QSE."
        return true;
      }
    },

  }
};
</script>

<style>
.divDuplication{
	text-align: center;
}
</style>